import  {  useContext, useEffect } from 'react';
import TeamTransfers from './TeamTransfers';
import { TeamContext } from '../../contexts/TeamContext';
import { Team } from '../../types';
import { useLocation } from 'react-router-dom';
import { Dropdown } from '../UI/Dropdown';
import LoadingSpinner from '../LoadingSpinner';
import { useCurrentGameweek } from '../../hooks/useCurrentGameweek';

function TeamTransfersDropdown() {
    const teamContext = useContext(TeamContext);
    const location = useLocation();

    if (!teamContext) {
        throw new Error("App must be used within a TeamProvider");
    }

    const state = location.state as { teamId?: number, gameweek?: number } | null;

    const { teams, selectedTeamId, setSelectedTeamId } = teamContext;
    const { currentGameweek, selectedGameweek, setSelectedGameweek } = useCurrentGameweek();

    useEffect(() => {
        if (state?.gameweek !== undefined && setSelectedGameweek) {
          setSelectedGameweek(state.gameweek);
        }
        if (state?.teamId !== undefined && setSelectedTeamId) {
          setSelectedTeamId(String(state.teamId));
        }
      }, [state?.gameweek, state?.teamId, setSelectedGameweek, setSelectedTeamId]);


    if (currentGameweek === null || selectedGameweek === null) {
        return <div className="flex justify-center items-center w-full h-full"><LoadingSpinner /></div>
    }

    const gameweeks = Array.from({ length: currentGameweek }, (_, i) => currentGameweek - i);

    return (
        <div>
            <div className='px-4 max-w-lg text-content m-auto p-8 flex gap-4 justify-center'>
                {teams.length > 0 && selectedTeamId && (
                    <Dropdown<Team>
                        id="team-select"
                        label=""
                        placeholder='Team'
                        options={teams}
                        value={teams.find(t => String(t.teamId) === selectedTeamId)!}
                        getOptionLabel={(team) => team.playerName}
                        getOptionValue={(team) => team.teamId}
                        onChange={(team) => setSelectedTeamId(String(team.teamId))}
                    />
                )}

                <Dropdown<number>
                    id="gameweek-select"
                    label=""
                    placeholder='Gameweek'
                    options={gameweeks}
                    value={selectedGameweek}
                    getOptionLabel={(gw) => "GW"+gw.toString()}
                    getOptionValue={(gw) => gw}
                    onChange={(gw) => {setSelectedGameweek(gw)}}
                />
            </div>
            <div className='py-4'>
                {selectedTeamId && selectedGameweek !== null && (
                    <TeamTransfers teamId={selectedTeamId} gameweek={selectedGameweek} />
                )}
            </div>


        </div>
    );
}

export default TeamTransfersDropdown;
